<template>
    <v-footer app class="py-1 footer-branded" name="footer">
        <v-card width="100%" flat class="bg-transparent">
            <v-card-text class="text-center pa-0">
                <span class="text-body-2 text-medium-emphasis">
                    <strong>SimpliGPS Go</strong> - Be in touch. &copy; {{ new Date().getFullYear() }} NextEra IoT.
                </span>
            </v-card-text>
        </v-card>
    </v-footer>
</template>

<script setup>
</script>

<style scoped>
.footer-branded {
    background: rgb(var(--v-theme-surface)) !important;
    border-top: 1px solid rgba(var(--v-border-color), var(--v-border-opacity)) !important;
}
</style>
